export default defineNuxtRouteMiddleware(async (to) => {
  const config = useRuntimeConfig()
  const externalURL = config.public.baseControleProcesssoURL
  
  if (!externalURL) return

  if (to.path === '/') {
    return navigateTo(externalURL, { external: true })
  }

  if (to.path === '/configuracoes') {
    const externalConfigURL = `${externalURL}/editar-serventia`
    return navigateTo(externalConfigURL, { external: true })
  }
}) 